import { getCrypto } from './windowSeams';

let usedIds: Set<string> = new Set();

// exposed for testing purposes
export function resetUsedIds(): void {
  usedIds.clear();
}

export function generateUniqueId(): string {
  // create a loop to check if Id is actually unique
  // if it is unique assign it.
  const MAX_RETRIES = 10; // Maximum number of attempts to generate a unique ID
  let retries = 0;
  let id = getNewId();
  while (usedIds.has(id)) {
    if (retries >= MAX_RETRIES) {
      throw new Error("Failed to generate a unique ID after maximum retries.");
    }
    id = getNewId();
    retries++;
  }
  usedIds.add(id);
  return id;
}

// Conforms to security rule "Using pseudorandom number generators (PRNGs) is security-sensitive"
// https://sonarqube.chrobinson.com/coding_rules?open=typescript%3AS2245&rule_key=typescript%3AS2245
function getNewId(): string {
  const crypto = getCrypto();
  const array = new Uint32Array(1);
  crypto.getRandomValues(array);
  return array[0].toString(36);
}